/* @ngInject */
const myAreaDisplay = () => {
  return {
    restrict: 'E',
    scope: {
      myArea: '=',
      myRailways: '=?',
      enableProgression: '=?',
      enableButtons: '=?',
      enableTitle: '=?',
      enableBack: '=?',
    },
    template: require('./myAreaDisplay.html'),

    /* @ngInject */
    controller: ($scope) => {

    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myAreaDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/area/directives/display/myAreaDisplay.js